import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";

export default function CDRTable({ data, slot, onPaginationModelChange, total, model }) {

    let rows = data || [];

    console.log(data, total, model);


    function handlePaginationModelChange(model) {
        if(onPaginationModelChange) {
            onPaginationModelChange(model);
        }
    }

    let columns = [
        { field: 'Country', headerName: 'Country', width: 80, sortable: false },
        { field: 'MobileNo', headerName: 'MobileNo', width: 120, sortable: false },
        { field: 'VMN', headerName: 'VMN', width: 120, sortable: false },
        { field: 'Trans_id', headerName: 'Transaction ID', width: 170, sortable: false },
        { field: 'DID', headerName: 'DID', width: 130, sortable: false },
        { field: 'MissedCall_Date', headerName: 'MissedCall Date', width: 130, sortable: false },
        { field: 'MissedCall_Time', headerName: 'MissedCall Time', width: 130, sortable: false },
        { field: 'Contestant_name', headerName: 'Contestant Name', width: 250, sortable: false },
        { field: 'status', headerName: 'Status', sortable: false },
    ]


    return (<>
        <div style={{ marginTop: '5px', marginBottom: '5px' }}>
        </div>
        <div style={{ marginTop: '5px', marginBottom: '5px'}}>
            { slot ?? null}
        </div>
        <DataGrid rows={rows} columns={columns} pageSizeOptions={[25,50,100]} getRowId={(r) => r.Trans_id}
            paginationModel={model}
            onPaginationModelChange={handlePaginationModelChange} 
            paginationMode="server"
            rowCount={total}/>
    </>)
}